export default __webpack_public_path__ + "static/media/cert-hkgcsmeaa.ad83f1dc.jpg";